import { NgModule } from '@angular/core';
import {StatefulButtonComponent} from './stateful-button.component';
import {CommonModule} from '@angular/common';



@NgModule({
  declarations: [StatefulButtonComponent],
  imports: [
    CommonModule
  ],
  exports: [
    StatefulButtonComponent
  ]
})
export class StatefulButtonModule { }
